import { render, staticRenderFns } from "./plyric.vue?vue&type=template&id=5df5d071&scoped=true&"
import script from "./plyric.vue?vue&type=script&lang=js&"
export * from "./plyric.vue?vue&type=script&lang=js&"
import style0 from "./plyric.vue?vue&type=style&index=0&id=5df5d071&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df5d071",
  null
  
)

export default component.exports